// Select: a native <select> in a bordered box with a chevron, and an optional lead inside the
// box (`lead`: a dot, a "repo" key). Ported from the Humint Assistant's components/ui/select.tsx.
import type { ComponentProps, ReactNode } from 'react';
import { cn } from './cn';

export const selectBox =
  'relative inline-flex h-[30px] min-w-0 max-w-full items-center gap-1.5 rounded border border-hairline bg-page pl-2.5 pr-2 text-[12.5px] text-ink-display' +
  ' focus-within:outline-2 focus-within:outline-offset-1 focus-within:outline-focus-ring coarse:min-h-10';

export interface SelectProps extends ComponentProps<'select'> {
  lead?: ReactNode;
  boxClassName?: string;
}

export function Select({ lead, className, boxClassName, children, ...props }: SelectProps) {
  return (
    <span className={cn(selectBox, boxClassName)}>
      {lead}
      <select
        className={cn(
          '-mr-3.5 min-w-0 max-w-[220px] cursor-pointer appearance-none truncate bg-transparent pr-3.5 focus-visible:outline-none phone:max-w-[150px] coarse:text-[16px]',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <svg className="pointer-events-none size-3 flex-none" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M4.5 6.5 8 10l3.5-3.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}
